import { X } from 'lucide-react'
import { formatAccessAgentMeta, getSelectedAccessAgents } from '../../utils/mlSheetAccessAgentList.js'

const MlAccessAgentChips = ({
  agents = [],
  selectedIds = [],
  users,
  onRemove,
  emptyLabel = 'No users selected',
}) => {
  const selected = users
    || getSelectedAccessAgents(agents, selectedIds)

  if (!selected.length) {
    return <p className="text-xs sm:text-sm text-gray-400 py-1">{emptyLabel}</p>
  }

  return (
    <div className="flex flex-wrap gap-1.5 w-full min-w-0 content-start">
      {selected.map((agent) => {
        const id = agent.user_id || agent.id
        const meta = formatAccessAgentMeta(agent)
        return (
          <span
            key={id || agent.name}
            className="inline-flex items-start gap-1 flex-[1_1_8.5rem] max-w-full min-w-0 rounded-lg border border-blue-200 bg-blue-50 px-2 py-1 text-xs text-blue-800"
          >
            <span className="min-w-0 flex-1">
              <span className="block font-medium whitespace-normal break-words [overflow-wrap:anywhere] leading-snug">
                {agent.name || id || 'User'}
              </span>
              {meta ? (
                <span className="block text-[10px] text-blue-600/80 whitespace-normal break-words [overflow-wrap:anywhere] leading-snug mt-0.5">
                  {meta}
                </span>
              ) : null}
            </span>
            {onRemove && id != null ? (
              <button
                type="button"
                onClick={() => onRemove(id)}
                className="shrink-0 mt-0.5 text-blue-500 hover:text-red-500"
                aria-label={`Remove ${agent.name || id}`}
              >
                <X className="w-3.5 h-3.5" />
              </button>
            ) : null}
          </span>
        )
      })}
    </div>
  )
}

export default MlAccessAgentChips
